import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { App } from '@capacitor/app';

import PlayerTag from './PlayerTag';

import { useApplication } from '../AppContext';

const MainMenu = () => {
	const { t } = useTranslation();

	const app = useApplication();

	const tapCount = React.useRef(0);

	const version = app.version;

	const showMoreGames = app.showMoreGames;

	const showAbout = app.config.showAbout;

	const navigate = React.useCallback((event, page) => {
		event.preventDefault();
		app.navigate(page);
	}, [app]);
	
	const tapTitle = React.useCallback(() => {
		const userdata = app.userdata;

		if(!userdata.stats) {
			userdata.stats = {};
		}

		userdata.stats.titleTapped = (userdata.stats.titleTapped || 0) + 1;
		app.achievements.checkForAchievementAndReward(userdata,userdata);
		
		app.save();
		// Trigger UI update
	}, [app]);

	const tapVersion = React.useCallback(() => {
		tapCount.current++;

		if (tapCount.current > 10) {
			app.navigate('Test');
		}
	}, [app]);

	const removeAds = React.useMemo(() => {
		if (!app.showRemoveAds) {
			return null;
		}

		return (
			<a href="#Store" onClick={event => navigate(event, 'Store')}>
				<i className="ui-icon ui-remove-ads" />
			</a>
		);
	}, [app.showRemoveAds, navigate]);

	React.useEffect(() => {
		const listener = () => {
			App.exitApp();
		};

		let removeHandler;

		App.addListener('backButton', listener).then((handle) => {
			removeHandler = handle.remove;
		});

		return () => {
			if (typeof removeHandler === 'function') {
				removeHandler();
			} else {
				App.removeAllListeners();
			}
		};
	}, []);

	return (
		<div id="MainMenu1" className="page1 activePage">
			<div className="wrapper">
				<div className="pageTitle" style={{
					padding: '50px 0 5px 0',
				}}>
					<img src="assets/Title.png" onClick={tapTitle} />
				</div>
				<ul className="buttonList" >
					<li>
						<a className="button buttonEasy" href="#ComputerMenu" onClick={event => navigate(event, 'ComputerMenu')}>
							{t('Play')}
						</a>
					</li>
					<li>
						<a className="button buttonMedium" href="#Online" onClick={event => navigate(event, 'Online')}>
							{t('Online')}
						</a>
					</li>
					<li>
						<a className="button buttonHard" href="#Achievements" onClick={event => navigate(event, 'Achievements')}>
							{t('Achievements')}
						</a>
					</li>
					<li>
						<PlayerTag   />
					</li>
					<li>
						<div className="minibuttons" >
							<a href="#HowToPlay" onClick={event => navigate(event, 'HowToPlay')}><i className="ui-icon ui-question-mark" /></a>

							<a href="#Achievements" onClick={event => navigate(event, 'Achievements')}><i className="ui-icon ui-achievement" /></a>
							<a href="#Statistics" onClick={event => navigate(event, 'Statistics')}><i className="ui-icon ui-stats" /></a>
							{showAbout && (<a href="#About" onClick={event => navigate(event, 'About')}><i className="ui-icon ui-mail" /></a>)}
							{/* <a data-show="showRateGame" > <img src="assets/Buttons/white/heart.png" /> </a> */}
							<a href="#Profile" onClick={event => navigate(event, 'Profile')}><i className="ui-icon ui-settings" /></a>
							{removeAds}
						</div>
					</li>
					{showMoreGames && (
						<li className="text-center">
							<div >
								<a className="buttonMoreGames" href="#MoreGames" onClick={event => navigate(event, 'MoreGames')}>
								</a>
								<div>{t('More Games')}</div>
							</div>
						</li>
					)}
					{!showMoreGames && (
						<li className="text-center" style={{
							margin: '8px 8px',
						}}>
							JD Games
						</li>
					)}

					<li className="text-center" style={{
						margin: '10px 10px',
						userSelect: 'none',
					}}>
						<div onClick={tapVersion}  >
							{version}
						</div>
					</li>
				</ul>
			</div>
		</div>
	);
};

export default MainMenu;
